// Preload WASM module early
import wasmInit from '../pkg/rust_terminal';

// Let wasm-bindgen handle the path via import.meta.url
export const wasmReady = wasmInit();
